import { render, staticRenderFns } from "./project_claim_list.vue?vue&type=template&id=68411857&scoped=true&"
import script from "./project_claim_list.vue?vue&type=script&lang=js&"
export * from "./project_claim_list.vue?vue&type=script&lang=js&"
import style0 from "./project_claim_list.vue?vue&type=style&index=0&id=68411857&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "68411857",
  null
  
)

export default component.exports